import type { ReactNode } from 'react';
import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { ascendTheme } from '../services/theme';

/**
 * ThemeProvider wraps the app with the static Ascend Platform MUI theme.
 * Dynamic per-tenant color theming has been removed; only logo branding remains
 * (handled directly in AppBar via tenantService).
 */
export function ThemeProvider({ children }: { children: ReactNode }) {
  return (
    <MuiThemeProvider theme={ascendTheme}>
      <CssBaseline />
      {children}
    </MuiThemeProvider>
  );
}
